import React, { useState } from 'react';
import { Save, Plus, Trash2 } from 'lucide-react';
import { apiCall, useAdminData } from './_helpers';

const UsersManager = ({ onMessage, currentUserId }) => {
  const [users, setUsers, refetch] = useAdminData('users');
  const [creating, setCreating] = useState(null);

  const save = async () => {
    try { await apiCall('POST', 'users', creating); onMessage('success', 'User created'); setCreating(null); refetch(); }
    catch (e) { onMessage('error', e.message); }
  };
  const remove = async (id) => {
    if (!window.confirm('Delete this user?')) return;
    try { await apiCall('DELETE', `users/${id}`); onMessage('success', 'Deleted'); refetch(); }
    catch (e) { onMessage('error', e.message); }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Admin Users</h2>
        <button onClick={() => setCreating({ email: '', password: '', name: '', role: 'admin' })}
          className="bg-[#C9A86C] text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-[#B8956A]">
          <Plus size={18} /> Add User
        </button>
      </div>
      {creating && (
        <div className="bg-white rounded-xl p-6 shadow-md mb-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input type="text" placeholder="Name" value={creating.name} onChange={(e) => setCreating({ ...creating, name: e.target.value })} className="border rounded-lg px-4 py-2" />
            <input type="email" placeholder="Email" value={creating.email} onChange={(e) => setCreating({ ...creating, email: e.target.value })} className="border rounded-lg px-4 py-2" />
            <input type="password" placeholder="Password" value={creating.password} onChange={(e) => setCreating({ ...creating, password: e.target.value })} className="border rounded-lg px-4 py-2" />
            <select value={creating.role} onChange={(e) => setCreating({ ...creating, role: e.target.value })} className="border rounded-lg px-4 py-2">
              <option value="admin">Admin</option>
              <option value="editor">Editor</option>
            </select>
          </div>
          <div className="flex gap-2 mt-4">
            <button onClick={save} className="bg-green-600 text-white px-4 py-2 rounded-lg flex items-center gap-2"><Save size={18} /> Save</button>
            <button onClick={() => setCreating(null)} className="bg-gray-500 text-white px-4 py-2 rounded-lg">Cancel</button>
          </div>
        </div>
      )}
      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-sm font-semibold">Name</th>
              <th className="px-6 py-3 text-left text-sm font-semibold">Email</th>
              <th className="px-6 py-3 text-left text-sm font-semibold">Role</th>
              <th className="px-6 py-3 text-left text-sm font-semibold">Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u._id} className="border-t">
                <td className="px-6 py-4">{u.name}</td>
                <td className="px-6 py-4">{u.email}</td>
                <td className="px-6 py-4"><span className="px-2 py-1 bg-[#C9A86C] text-white text-xs rounded">{u.role}</span></td>
                <td className="px-6 py-4">{u._id !== currentUserId && (<button onClick={() => remove(u._id)} className="text-red-600 hover:bg-red-50 p-2 rounded"><Trash2 size={18} /></button>)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UsersManager;
